import React from 'react';

import { type DetailsPageRightSidebarProps } from 'app/main/components/page-layouts';

import DemsDetailsSectionStats from './sections/DemsDetailsSectionStats';
import DemsDetailsSectionManager from './sections/DemsDetailsSectionManager';

export default function DemsDetailsRightSidebar(props: DetailsPageRightSidebarProps) {
	const sections: React.ReactNode[] = [];

	if (!props.isAdd) {
		if (props.model.dems_sent) {
			sections.push(<DemsDetailsSectionStats model={props.model} />);
		}

		sections.push(<DemsDetailsSectionManager model={props.model} updateRefresh={props.updateRefresh} />);
	}

	return sections;
}
